import React from 'react';

interface InputBoxProperties {
  label: string;
  placeholder?: string;
  type: string;
  value: string;
  name: string;
  onChange: (name: string, value: string | number) => void;
  icon?: React.ReactNode; // Optional icon
  className?: string; // Optional class for additional styling
  readonly?: boolean;
}
/**
 * params
 * @param param0
 * @returns
 */
function InputBox({
  label,
  placeholder,
  value,
  onChange,
  icon,
  name,
  className,
  type,
  readonly,
}: InputBoxProperties) {
  /**
   * rules
   * @param changeValue
   */
  const handleValueChange = (changeValue: string | number) => {
    onChange(name, changeValue);
  };

  return (
    <div className={`input-box ${className}`}>
      <span className="input-label">{icon && <span className="input-icon">{icon}</span>}</span>
      <input
        type={type}
        value={value}
        onChange={(event) => handleValueChange(event.target.value)}
        className="input-field"
        readOnly={readonly}
        required
      />
      <span className={value === '' ? 'input-placeholder' : 'input-placeholder-hover'}>
        {placeholder}
      </span>
      <span className="input-label-value">{label}</span>
    </div>
  );
}
InputBox.defaultProps = {
  placeholder: '', // Default placeholder
  icon: null, // Default icon
  className: '',
  readonly: false,
};

export default InputBox;
